import { Routes } from '@angular/router';
import { LumenDiagnosticsComponent } from '@app/features/lumen-diagnostics/lumen-diagnostics.component';
import { Authority } from '@app/shared/utils/enums';

export const lumenDiagnisticRoutes: Routes = [
    {
        path: 'lumen-diagnostics',
        children: [
            {
                path: '',
                component: LumenDiagnosticsComponent,
                data: {
                    authorities: [Authority.ADMIN]
                }
            }
        ]
    }
]